import React from "react";
import InterruptButton from "@components/FlowActionButtons/InterruptButton";
import { canUserInterrupt } from "../utils";

interface InterruptVesselCallProps {
  vesselCallFlowData?: {
    status: string;
  };
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const InterruptVesselCall: React.FC<InterruptVesselCallProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
}) => {
  if (!vesselCallFlowData) {
    return null;
  }

  const isActionAvailable = canUserInterrupt(vesselCallFlowData.status);
  const handleInterruptClick = () => {
    refetchVesselCall();
    openDrawer("interruptDrawer");
  };
  return (
    <InterruptButton
      langBase={LANG_BASE}
      permission="canInterruptVesselCall"
      isActionAvailable={isActionAvailable}
      onInterrupt={handleInterruptClick}
    />
  );
};

export default InterruptVesselCall;
